module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getDevices
    },
    model: {
      value: (_vm.filters.projectId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "projectId", $$v)
      },
      expression: "filters.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点位名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.mn),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mn", $$v)
      },
      expression: "filters.mn"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.mnCode,
      attrs: {
        "label": item.name,
        "value": item.mnCode
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.type == 0) ? _c('el-form-item', {
    attrs: {
      "label": "设备编码"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.mn),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mn", $$v)
      },
      expression: "filters.mn"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.mnCode,
      attrs: {
        "label": item.mnCode,
        "value": item.mnCode
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": "",
      "highlight-current-row": "",
      "height": _vm.formHeight,
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "no",
      "label": "测点编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "测点位置"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "people",
      "label": "监测人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "queue",
      "label": "区域"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.queueId == 1) ? _c('span', [_vm._v("一类")]) : (scope.row.queueId == 2) ? _c('span', [_vm._v("二类")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startTime",
      "label": "开始时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endTime",
      "label": "结束时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', [_vm._v("已计算")]) : (scope.row.status == 0) ? _c('span', [_vm._v("未计算")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('table-update-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [10, 20, 30, 40, 50],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改",
      "visible": _vm.formVisible,
      "close-on-click-modal": false,
      "width": "60%",
      "top": "5vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formSetData",
    attrs: {
      "model": _vm.formSetData,
      "label-width": "120px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "测点编号",
      "prop": "no"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formSetData.no),
      callback: function($$v) {
        _vm.$set(_vm.formSetData, "no", $$v)
      },
      expression: "formSetData.no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "测点位置",
      "prop": "address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formSetData.address),
      callback: function($$v) {
        _vm.$set(_vm.formSetData, "address", $$v)
      },
      expression: "formSetData.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "监测人",
      "prop": "people"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formSetData.people),
      callback: function($$v) {
        _vm.$set(_vm.formSetData, "people", $$v)
      },
      expression: "formSetData.people"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域",
      "prop": "queueId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择区域"
    },
    model: {
      value: (_vm.formSetData.queueId),
      callback: function($$v) {
        _vm.$set(_vm.formSetData, "queueId", $$v)
      },
      expression: "formSetData.queueId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "一类",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二类",
      "value": 2
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-5f3a06d8"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flight/FlightSet.vue
// module id = 1929
// module chunks = 1